import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCart } from "./CartContext";
import CustomSizeForm from "./CustomSizeForm";
import CustomizationOptions from "./CustomizationOptions";
import "./ProductDetails.css";

// =====================================================
// MEN'S PRODUCTS
// =====================================================

import product1 from "../Images/mens20.jpg";
import product2 from "../Images/mens11.jpg";
import product3 from "../Images/mens12.jpg";
import product4 from "../Images/mens26.png";
import product5 from "../Images/mens16.jpg";
import product6 from "../Images/mens27.png";
import product7 from "../Images/mens28.png";
import product8 from "../Images/mens22.jpg";

// =====================================================
// FEATURED PRODUCTS 301 - 310
// =====================================================

import featured1 from "../Images/green6.jpg";
import featured2 from "../Images/image33.png";
import featured3 from "../Images/mix1.jpg";
import featured4 from "../Images/orange3.jpg";
import featured5 from "../Images/yellowblue3.jpg";
import featured6 from "../Images/red3.jpg";
import featured7 from "../Images/yellow7.jpg";
import featured8 from "../Images/orange10.jpg";
import featured9 from "../Images/blue3.jpg";
import featured10 from "../Images/south7.jpeg";

// =====================================================
// WOMEN'S VIEW ALL
// =====================================================

import women101 from "../Images/blue1.jpg";
import women102 from "../Images/orange5.jpg";
import women103 from "../Images/yellow5.jpg";
import women104 from "../Images/blue2.jpg";
import women105 from "../Images/darkgreen2.jpg";
import women106 from "../Images/green1.jpg";
import women107 from "../Images/image30.png";
import women108 from "../Images/image33.png";
import women109 from "../Images/yellow5.jpg";
import women110 from "../Images/grey1.jpg";
import women111 from "../Images/image41.png";
import women112 from "../Images/image39.png";
import women113 from "../Images/south8.jpeg";
import women114 from "../Images/yellow9.jpg";
import women115 from "../Images/image30.png";
import women116 from "../Images/south11.jpeg";
import women117 from "../Images/green7.jpg";
import women118 from "../Images/image31.png";
import women119 from "../Images/orange10.jpg";
import women120 from "../Images/red7.jpg";
import women121 from "../Images/yellowgreen1.png";
import women122 from "../Images/orange3.jpg";
import women123 from "../Images/image38.png";
import women124 from "../Images/green5.jpg";
import women125 from "../Images/darkgreen1.jpg";
import women126 from "../Images/mix1.jpg";
import women127 from "../Images/darkgreen3.jpg";
import women128 from "../Images/red3.jpg";
import women129 from "../Images/orange4.jpg";
import women130 from "../Images/yellow8.jpg";
import women131 from "../Images/red3.jpg";
import women132 from "../Images/black1.jpg";
import women133 from "../Images/blue6.jpg";

// =====================================================
// HOME COLLECTION
// =====================================================

import home201 from "../Images/green1.jpg";
import home202 from "../Images/image33.png";
import home203 from "../Images/grey1.jpg";
import home204 from "../Images/newcollection4.jpg";
import home205 from "../Images/image30.png";
import home206 from "../Images/south10.jpeg";
import home207 from "../Images/image31.png";
import home208 from "../Images/orange11.jpg";

// =====================================================
// PRODUCTS
// =====================================================

const products = [
  // ===================================================
  // MEN'S 1 - 8
  // ===================================================

  {
    id: 1,
    name: "African Dress 1",
    image: product1,
    price: 149.99,
    oldPrice: 187.49,
    discount: 20,
    category: "Men",
  },
  {
    id: 2,
    name: "African Dress 2",
    image: product2,
    price: 159.99,
    oldPrice: 188.22,
    discount: 15,
    category: "Men",
  },
  {
    id: 3,
    name: "African Dress 3",
    image: product3,
    price: 129.99,
    oldPrice: 144.43,
    discount: 10,
    category: "Men",
  },
  {
    id: 4,
    name: "African Dress 4",
    image: product4,
    price: 189.99,
    oldPrice: 253.32,
    discount: 25,
    category: "Men",
  },
  {
    id: 5,
    name: "African Dress 5",
    image: product5,
    price: 139.99,
    oldPrice: 147.36,
    discount: 5,
    category: "Men",
  },
  {
    id: 6,
    name: "African Dress 6",
    image: product6,
    price: 169.99,
    oldPrice: 242.84,
    discount: 30,
    category: "Men",
  },
  {
    id: 7,
    name: "African Dress 7",
    image: product7,
    price: 119.99,
    oldPrice: 133.32,
    discount: 10,
    category: "Men",
  },
  {
    id: 8,
    name: "African Dress 8",
    image: product8,
    price: 199.99,
    oldPrice: 249.99,
    discount: 20,
    category: "Men",
  },

  // ===================================================
  // FEATURED PRODUCTS 301 - 310
  // ===================================================

  {
    id: 301,
    name: "African Dress 1",
    image: featured1,
    price: 149.99,
    oldPrice: 187.49,
    discount: 20,
    category: "Women",
  },
  {
    id: 302,
    name: "African Dress 2",
    image: featured2,
    price: 159.99,
    oldPrice: 188.22,
    discount: 15,
    category: "Women",
  },
  {
    id: 303,
    name: "African Dress 3",
    image: featured3,
    price: 129.99,
    oldPrice: 144.43,
    discount: 10,
    category: "Women",
  },
  {
    id: 304,
    name: "African Dress 4",
    image: featured4,
    price: 189.99,
    oldPrice: 253.32,
    discount: 25,
    category: "Women",
  },
  {
    id: 305,
    name: "African Dress 5",
    image: featured5,
    price: 139.99,
    oldPrice: 147.36,
    discount: 5,
    category: "Women",
  },
  {
    id: 306,
    name: "African Dress 6",
    image: featured6,
    price: 169.99,
    oldPrice: 242.84,
    discount: 30,
    category: "Women",
  },
  {
    id: 307,
    name: "African Dress 7",
    image: featured7,
    price: 119.99,
    oldPrice: 133.32,
    discount: 10,
    category: "Women",
  },
  {
    id: 308,
    name: "African Dress 8",
    image: featured8,
    price: 199.99,
    oldPrice: 249.99,
    discount: 20,
    category: "Women",
  },
  {
    id: 309,
    name: "African Dress 9",
    image: featured9,
    price: 199.99,
    oldPrice: 249.99,
    discount: 20,
    category: "Women",
  },
  {
    id: 310,
    name: "African Dress 10",
    image: featured10,
    price: 199.99,
    oldPrice: 249.99,
    discount: 20,
    category: "Women",
  },

  // ===================================================
  // WOMEN'S 101 - 133
  // ===================================================

  {
    id: 101,
    name: "African Print Dress",
    image: women101,
    price: 49.99,
    oldPrice: 69.99,
    category: "Women",
  },
  {
    id: 102,
    name: "African Elegant Dress",
    image: women102,
    price: 59.99,
    oldPrice: 79.99,
    category: "Women",
  },
  {
    id: 103,
    name: "African Fashion Dress",
    image: women103,
    price: 54.99,
    oldPrice: 74.99,
    category: "Women",
  },
  {
    id: 104,
    name: "Traditional African Dress",
    image: women104,
    price: 64.99,
    oldPrice: 84.99,
    category: "Women",
  },
  {
    id: 105,
    name: "African Maxi Dress",
    image: women105,
    price: 69.99,
    oldPrice: 89.99,
    category: "Women",
  },
  {
    id: 106,
    name: "African Pattern Dress",
    image: women106,
    price: 49.99,
    oldPrice: 65.99,
    category: "Women",
  },
  {
    id: 107,
    name: "Luxury African Dress",
    image: women107,
    price: 79.99,
    oldPrice: 99.99,
    category: "Women",
  },
  {
    id: 108,
    name: "African Occasion Dress",
    image: women108,
    price: 74.99,
    oldPrice: 94.99,
    category: "Women",
  },
  {
    id: 109,
    name: "African Print Gown",
    image: women109,
    price: 89.99,
    oldPrice: 109.99,
    category: "Women",
  },
  {
    id: 110,
    name: "African Casual Dress",
    image: women110,
    price: 44.99,
    oldPrice: 59.99,
    category: "Women",
  },
  {
    id: 111,
    name: "African Designer Dress",
    image: women111,
    price: 84.99,
    oldPrice: 109.99,
    category: "Women",
  },
  {
    id: 112,
    name: "African Long Dress",
    image: women112,
    price: 69.99,
    oldPrice: 89.99,
    category: "Women",
  },
  {
    id: 113,
    name: "African Floral Dress",
    image: women113,
    price: 54.99,
    oldPrice: 69.99,
    category: "Women",
  },
  {
    id: 114,
    name: "African Modern Dress",
    image: women114,
    price: 59.99,
    oldPrice: 79.99,
    category: "Women",
  },
  {
    id: 115,
    name: "African Premium Dress",
    image: women115,
    price: 94.99,
    oldPrice: 119.99,
    category: "Women",
  },
  {
    id: 116,
    name: "African Party Dress",
    image: women116,
    price: 74.99,
    oldPrice: 94.99,
    category: "Women",
  },
  {
    id: 117,
    name: "African Cotton Dress",
    image: women117,
    price: 49.99,
    oldPrice: 64.99,
    category: "Women",
  },
  {
    id: 118,
    name: "African Summer Dress",
    image: women118,
    price: 59.99,
    oldPrice: 74.99,
    category: "Women",
  },
  {
    id: 119,
    name: "African Heritage Dress",
    image: women119,
    price: 79.99,
    oldPrice: 99.99,
    category: "Women",
  },
  {
    id: 120,
    name: "African Classic Dress",
    image: women120,
    price: 69.99,
    oldPrice: 89.99,
    category: "Women",
  },
  {
    id: 121,
    name: "African Printed Gown",
    image: women121,
    price: 89.99,
    oldPrice: 109.99,
    category: "Women",
  },
  {
    id: 122,
    name: "African Evening Dress",
    image: women122,
    price: 79.99,
    oldPrice: 99.99,
    category: "Women",
  },
  {
    id: 123,
    name: "African Style Dress",
    image: women123,
    price: 64.99,
    oldPrice: 84.99,
    category: "Women",
  },
  {
    id: 124,
    name: "African Couture Dress",
    image: women124,
    price: 99.99,
    oldPrice: 129.99,
    category: "Women",
  },
  {
    id: 125,
    name: "African Beauty Dress",
    image: women125,
    price: 69.99,
    oldPrice: 89.99,
    category: "Women",
  },
  {
    id: 126,
    name: "African Elegant Gown",
    image: women126,
    price: 89.99,
    oldPrice: 109.99,
    category: "Women",
  },
  {
    id: 127,
    name: "African Statement Dress",
    image: women127,
    price: 74.99,
    oldPrice: 94.99,
    category: "Women",
  },
  {
    id: 128,
    name: "African Handmade Dress",
    image: women128,
    price: 84.99,
    oldPrice: 104.99,
    category: "Women",
  },
  {
    id: 129,
    name: "African Signature Dress",
    image: women129,
    price: 94.99,
    oldPrice: 119.99,
    category: "Women",
  },
  {
    id: 130,
    name: "African Royal Dress",
    image: women130,
    price: 109.99,
    oldPrice: 139.99,
    category: "Women",
  },
  {
    id: 131,
    name: "African Royal Dress",
    image: women131,
    price: 109.99,
    oldPrice: 139.99,
    category: "Women",
  },
  {
    id: 132,
    name: "African Royal Dress",
    image: women132,
    price: 109.99,
    oldPrice: 139.99,
    category: "Women",
  },
  {
    id: 133,
    name: "African Royal Dress",
    image: women133,
    price: 109.99,
    oldPrice: 139.99,
    category: "Women",
  },

  // ===================================================
  // HOME COLLECTION 201 - 208
  // ===================================================

  {
    id: 201,
    name: "African Green Collection Dress",
    image: home201,
    price: 59.99,
    oldPrice: 79.99,
    category: "Women",
  },
  {
    id: 202,
    name: "African Elegant Collection Dress",
    image: home202,
    price: 89.99,
    oldPrice: 119.99,
    category: "Women",
  },
  {
    id: 203,
    name: "African Grey Collection Dress",
    image: home203,
    price: 79.99,
    oldPrice: 99.99,
    category: "Women",
  },
  {
    id: 204,
    name: "African Summer Collection Dress",
    image: home204,
    price: 69.99,
    oldPrice: 89.99,
    category: "Women",
  },
  {
    id: 205,
    name: "African Luxury Collection Dress",
    image: home205,
    price: 99.99,
    oldPrice: 129.99,
    category: "Women",
  },
  {
    id: 206,
    name: "African Traditional Collection Dress",
    image: home206,
    price: 84.99,
    oldPrice: 109.99,
    category: "Women",
  },
  {
    id: 207,
    name: "African Classic Collection Dress",
    image: home207,
    price: 79.99,
    oldPrice: 99.99,
    category: "Women",
  },
  {
    id: 208,
    name: "African Orange Collection Dress",
    image: home208,
    price: 89.99,
    oldPrice: 119.99,
    category: "Women",
  },
];

// =====================================================
// SIZE CHART
// =====================================================

const sizeChart = {
  S: {
    chest: '36"',
    bust: '36"',
    waist: '30"',
    shoulder: '15"',
    sleeve: '23"',
    length: '42"',
    hip: '38"',
  },
  M: {
    chest: '38"',
    bust: '38"',
    waist: '32"',
    shoulder: '15.5"',
    sleeve: '23.5"',
    length: '43"',
    hip: '40"',
  },
  L: {
    chest: '40"',
    bust: '40"',
    waist: '34"',
    shoulder: '16"',
    sleeve: '24"',
    length: '44"',
    hip: '42"',
  },
  XL: {
    chest: '42"',
    bust: '42"',
    waist: '36"',
    shoulder: '16.5"',
    sleeve: '24.5"',
    length: '45"',
    hip: '44"',
  },
  XXL: {
    chest: '44"',
    bust: '44"',
    waist: '38"',
    shoulder: '17"',
    sleeve: '25"',
    length: '46"',
    hip: '46"',
  },
};

// =====================================================
// COMPONENT
// =====================================================

function ProductDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();

  // ===================================================
  // SIZE STATES
  // ===================================================

  const [selectedSize, setSelectedSize] = useState("");
  const [showSizeChart, setShowSizeChart] = useState(false);
  const [sizeError, setSizeError] = useState("");

  // ===================================================
  // CUSTOM SIZE STATES
  // ===================================================

  const [isCustomSize, setIsCustomSize] = useState(false);
  const [customMeasurements, setCustomMeasurements] = useState(null);

  // ===================================================
  // CUSTOMISATION STATES
  // ===================================================

  const [isCustomizationOpen, setIsCustomizationOpen] =
    useState(false);

  const [customization, setCustomization] =
    useState(null);

  // ===================================================
  // FIND PRODUCT
  // ===================================================

  const product = products.find(
    (item) => item.id === Number(id)
  );

  // ===================================================
  // PRODUCT NOT FOUND
  // ===================================================

  if (!product) {
    return (
      <div className="product-not-found">
        <h2>Product Not Found</h2>

        <button
          type="button"
          onClick={() => navigate("/view-all")}
        >
          Back to Shopping
        </button>
      </div>
    );
  }

  // ===================================================
  // DISCOUNT
  // ===================================================

  const calculatedDiscount =
    product.discount ||
    Math.round(
      ((product.oldPrice - product.price) /
        product.oldPrice) *
        100
    );

  // ===================================================
  // SIZE SELECT
  // ===================================================

  const handleSizeSelect = (size) => {
    setSelectedSize(size);
    setIsCustomSize(false);
    setCustomMeasurements(null);
    setSizeError("");
  };

  // ===================================================
  // CUSTOM SIZE SELECT
  // ===================================================

  const handleCustomSizeSelect = () => {
    setSelectedSize("Custom");
    setIsCustomSize(true);
    setSizeError("");
  };

  // ===================================================
  // CUSTOM MEASUREMENTS SAVE
  // ===================================================

  const handleSaveCustomMeasurements = (measurements) => {
    setCustomMeasurements(measurements);
    setSelectedSize("Custom");
    setIsCustomSize(false);
    setSizeError("");
  };

  // ===================================================
  // OPEN CUSTOMISATION
  // ===================================================

  const handleOpenCustomization = () => {
    setIsCustomizationOpen(true);
    setSizeError("");
  };

  // ===================================================
  // SAVE CUSTOMISATION
  // ===================================================

  const handleSaveCustomization = (
    customizationData
  ) => {
    setCustomization(customizationData);
    setIsCustomizationOpen(false);
  };

  // ===================================================
  // REMOVE CUSTOMISATION
  // ===================================================

  const handleRemoveCustomization = () => {
    setCustomization(null);
    setIsCustomizationOpen(false);
  };

  // ===================================================
  // FINAL PRICE
  // ===================================================

  const customizationExtraPrice = Number(
    customization?.extraPrice || 0
  );

  const finalProductPrice =
    Number(product.price || 0) +
    customizationExtraPrice;

  // ===================================================
  // CREATE CART PRODUCT
  // ===================================================

  const createCartProduct = () => {
    return {
      id: product.id,

      name: product.name,

      img: product.image,

      image: product.image,

      // Final price including customization
      price: finalProductPrice,

      // Original product price
      basePrice: Number(product.price || 0),

      // Extra customization price
      customizationExtraPrice:
        customizationExtraPrice,

      oldPrice: Number(product.oldPrice || 0),

      originalPrice:
        Number(product.oldPrice || 0),

      discount: calculatedDiscount,

      selectedSize: selectedSize,

      category: product.category,

      // Custom Size
      isCustomSize:
        selectedSize === "Custom",

      customMeasurements:
        customMeasurements,

      // Customisation Options
      customization:
        customization,
    };
  };

  // ===================================================
  // VALIDATE PRODUCT
  // ===================================================

  const validateProduct = () => {
    // Size required
    if (!selectedSize) {
      setSizeError("Please select a size.");
      return false;
    }

    // Custom measurements required
    if (
      selectedSize === "Custom" &&
      !customMeasurements
    ) {
      setSizeError(
        "Please enter and save your custom measurements."
      );

      setIsCustomSize(true);

      return false;
    }

    return true;
  };

  // ===================================================
  // ADD TO CART
  // ===================================================

  const handleAddToCart = () => {
    const isValid = validateProduct();

    if (!isValid) {
      return;
    }

    const cartProduct = createCartProduct();

    addToCart(cartProduct);

    navigate("/cart");
  };

  // ===================================================
  // BUY NOW
  // ===================================================

  const handleBuyNow = () => {
    const isValid = validateProduct();

    if (!isValid) {
      return;
    }

    const cartProduct = createCartProduct();

    addToCart(cartProduct);

    navigate("/payment");
  };

  return (
    <div className="product-details-page">

      <div className="product-details-container">

        {/* =================================================
            PRODUCT IMAGE
        ================================================= */}

        <div className="product-details-image-section">

          <div className="product-details-image-wrapper">

            <img
              src={product.image}
              alt={product.name}
              className="product-details-main-image"
            />

          </div>

        </div>


        {/* =================================================
            PRODUCT INFORMATION
        ================================================= */}

        <div className="product-details-info">

          <h1 className="product-details-title">
            {product.name}
          </h1>


          {/* =================================================
              PRICE
          ================================================= */}

          <div className="product-details-price-box">

            <span className="product-details-price">
              £{finalProductPrice.toFixed(2)}
            </span>

            {customizationExtraPrice > 0 && (
              <span
                style={{
                  fontSize: "12px",
                  color: "#765334",
                  marginLeft: "8px",
                }}
              >
                Customisation included
              </span>
            )}

            <span className="product-details-old-price">
              £{product.oldPrice.toFixed(2)}
            </span>

            <span className="product-details-discount">
              {calculatedDiscount}% OFF
            </span>

          </div>

          <p className="product-details-price-note">
            Inclusive of all applicable taxes
          </p>

          <div className="product-details-divider"></div>


          {/* =================================================
              SIZE SECTION
          ================================================= */}

          <div className="product-size-section">

            <div className="product-size-heading-row">

              <h3>
                Select Size
              </h3>

              <button
                type="button"
                className="size-chart-btn"
                onClick={() =>
                  setShowSizeChart(true)
                }
              >
                Size Chart
              </button>

            </div>


            <div className="product-size-buttons">

              {Object.keys(sizeChart).map(
                (size) => (

                  <button
                    key={size}
                    type="button"
                    className={`product-size-btn ${
                      selectedSize === size
                        ? "active"
                        : ""
                    }`}
                    onClick={() =>
                      handleSizeSelect(size)
                    }
                  >
                    {size}
                  </button>

                )
              )}


              {/* =================================================
                  CUSTOM SIZE BUTTON
              ================================================= */}

              <button
                type="button"
                className={`product-size-btn custom-size-btn ${
                  selectedSize === "Custom"
                    ? "active"
                    : ""
                }`}
                onClick={handleCustomSizeSelect}
              >
                Custom Size ✨
              </button>

            </div>


            {/* =================================================
                SIZE ERROR
            ================================================= */}

            {sizeError && (
              <p
                style={{
                  color: "red",
                  marginTop: "10px",
                  fontSize: "14px",
                }}
              >
                {sizeError}
              </p>
            )}

          </div>


          {/* =================================================
              CUSTOM SIZE FORM
          ================================================= */}

          {isCustomSize && (

            <CustomSizeForm
              onSave={
                handleSaveCustomMeasurements
              }
              onCancel={() => {

                setIsCustomSize(false);

                if (!customMeasurements) {
                  setSelectedSize("");
                }

              }}
            />

          )}


          {/* =================================================
              CUSTOM SIZE SAVED
          ================================================= */}

          {selectedSize === "Custom" &&
            customMeasurements &&
            !isCustomSize && (

              <div className="custom-measurements-saved">

                <div>

                  <strong>
                    ✓ Custom Measurements Saved
                  </strong>

                  <p>
                    Your dress will be prepared
                    according to your measurements.
                  </p>

                </div>

                <button
                  type="button"
                  onClick={() =>
                    setIsCustomSize(true)
                  }
                >
                  Edit
                </button>

              </div>

            )}


          {/* =================================================
              SELECTED NORMAL SIZE DETAILS
          ================================================= */}

          {selectedSize &&
            selectedSize !== "Custom" && (

              <div className="selected-size-details">

                <h4>
                  Selected Size: {selectedSize}
                </h4>

                <div className="selected-measurements-grid">

                  <div>
                    <span>Chest</span>
                    <strong>
                      {
                        sizeChart[
                          selectedSize
                        ].chest
                      }
                    </strong>
                  </div>

                  <div>
                    <span>Bust</span>
                    <strong>
                      {
                        sizeChart[
                          selectedSize
                        ].bust
                      }
                    </strong>
                  </div>

                  <div>
                    <span>Waist</span>
                    <strong>
                      {
                        sizeChart[
                          selectedSize
                        ].waist
                      }
                    </strong>
                  </div>

                  <div>
                    <span>Shoulder</span>
                    <strong>
                      {
                        sizeChart[
                          selectedSize
                        ].shoulder
                      }
                    </strong>
                  </div>

                  <div>
                    <span>Sleeve</span>
                    <strong>
                      {
                        sizeChart[
                          selectedSize
                        ].sleeve
                      }
                    </strong>
                  </div>

                  <div>
                    <span>Length</span>
                    <strong>
                      {
                        sizeChart[
                          selectedSize
                        ].length
                      }
                    </strong>
                  </div>

                  <div>
                    <span>Hip</span>
                    <strong>
                      {
                        sizeChart[
                          selectedSize
                        ].hip
                      }
                    </strong>
                  </div>

                </div>

              </div>

            )}


          {/* =================================================
              CUSTOMISATION OPTIONS
          ================================================= */}

          <div className="product-customization-section">

            <div className="product-customization-heading">

              <div>

                <span className="product-customization-label">
                  PERSONALISE YOUR OUTFIT
                </span>

                {/* <h3>
                  Customisation Options
                </h3> */}

              </div>


              {customization && (

                <span className="customization-saved-badge">
                  ✓ Saved
                </span>

              )}

            </div>


            {/* =================================================
                OPEN BUTTON
            ================================================= */}

            {!isCustomizationOpen &&
              !customization && (

                <button
                  type="button"
                  className="open-customization-btn"
                  onClick={
                    handleOpenCustomization
                  }
                >
                  ✨ Customise This Outfit
                </button>

              )}


            {/* =================================================
                SAVED CUSTOMISATION
            ================================================= */}

            {!isCustomizationOpen &&
              customization && (

                <div className="customization-saved-box">

                  <div>

                    <strong>
                      ✓ Customisation Saved
                    </strong>

                    <p>
                      Your selected customisation
                      will be applied to this product.
                    </p>

                  </div>


                  <div className="customization-saved-actions">

                    <button
                      type="button"
                      onClick={() =>
                        setIsCustomizationOpen(true)
                      }
                    >
                      Edit
                    </button>

                    <button
                      type="button"
                      onClick={
                        handleRemoveCustomization
                      }
                    >
                      Remove
                    </button>

                  </div>

                </div>

              )}


            {/* =================================================
                CUSTOMISATION FORM
            ================================================= */}

            {isCustomizationOpen && (

              <CustomizationOptions
                initialCustomization={
                  customization
                }
                onSave={
                  handleSaveCustomization
                }
                onCancel={() =>
                  setIsCustomizationOpen(false)
                }
              />

            )}

          </div>


          {/* =================================================
              ADD TO CART + BUY NOW
          ================================================= */}

          <div className="product-details-actions">

            <button
              type="button"
              className="product-add-cart-btn"
              onClick={handleAddToCart}
            >
              Add to Cart
            </button>

            <button
              type="button"
              className="product-buy-now-btn"
              onClick={handleBuyNow}
            >
              Buy Now
            </button>

          </div>


          {/* =================================================
              EXTRA INFORMATION
          ================================================= */}

          <div className="product-extra-info">

            <div className="product-info-item">
              🚚 <strong>Free Shipping</strong>
            </div>

            <div className="product-info-item">
              🔄 <strong>Easy Returns</strong>
            </div>

            <div className="product-info-item">
              🔒 <strong>Secure Payment</strong>
            </div>

          </div>

        </div>

      </div>


      {/* =================================================
          SIZE CHART MODAL
      ================================================= */}

      {showSizeChart && (

        <div
          className="size-chart-overlay"
          onClick={() =>
            setShowSizeChart(false)
          }
        >

          <div
            className="size-chart-modal"
            onClick={(e) =>
              e.stopPropagation()
            }
          >

            <div className="size-chart-header">

              <h2>
                Size Chart
              </h2>

              <button
                type="button"
                onClick={() =>
                  setShowSizeChart(false)
                }
              >
                ×
              </button>

            </div>


            <div className="size-chart-table-wrapper">

              <table className="size-chart-table">

                <thead>

                  <tr>
                    <th>Size</th>
                    <th>Chest</th>
                    <th>Bust</th>
                    <th>Waist</th>
                    <th>Shoulder</th>
                    <th>Sleeve</th>
                    <th>Length</th>
                    <th>Hip</th>
                  </tr>

                </thead>


                <tbody>

                  {Object.entries(sizeChart).map(
                    ([size, measurements]) => (

                      <tr key={size}>

                        <td>
                          <strong>
                            {size}
                          </strong>
                        </td>

                        <td>
                          {measurements.chest}
                        </td>

                        <td>
                          {measurements.bust}
                        </td>

                        <td>
                          {measurements.waist}
                        </td>

                        <td>
                          {measurements.shoulder}
                        </td>

                        <td>
                          {measurements.sleeve}
                        </td>

                        <td>
                          {measurements.length}
                        </td>

                        <td>
                          {measurements.hip}
                        </td>

                      </tr>

                    )
                  )}

                </tbody>

              </table>

            </div>

          </div>

        </div>

      )}

    </div>
  );
}

export default ProductDetails;
